import { useMutation } from '@apollo/client';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import UPDATE_USER_AVATAR from 'api/mutations/UPDATE_USER_AVATAR';
import PROFILE from 'api/queries/PROFILE';
import Loader from 'layout/atoms/Loader/Loader';
import ParameterDetails from 'layout/atoms/ParameterDetails/ParameterDetails';
import Photo from 'layout/atoms/Photo/Photo';
import Subtitle from 'layout/atoms/Subtitle';
import Grid from 'layout/molecules/Grid/Grid';
import Dashboard from 'layout/templates/Dashboard/Dashboard';
import { clearBreadcrumbs, setBreadcrumbs } from 'store/layoutSlice';
import { selectUserProfileDataData, selectUserProfileDataStatus, updateUserAvatar, updateUserAvatarStore, } from 'store/userSlice';
import env from 'utils/env';
import { withAttachments } from 'utils/graphql';
function UserProfileView() {
    const { t } = useTranslation(['common', 'LAYOUT']);
    const dispatch = useDispatch();
    const [profile, setProfile] = useState(null);
    const userProfileStatus = useSelector(selectUserProfileDataStatus);
    const userProfileData = useSelector(selectUserProfileDataData);
    const [updateAvatar] = useMutation(UPDATE_USER_AVATAR);
    useEffect(() => {
        dispatch(setBreadcrumbs([{ to: '/user-profile', name: t('LAYOUT:SIDEBAR_MENU_PROFILE') }]));
        return () => {
            dispatch(clearBreadcrumbs());
        };
    }, [dispatch, t]);
    useEffect(() => {
        if (userProfileStatus === 'succeeded') {
            const userProfileStr = localStorage.getItem('userProfile');
            if (userProfileStr)
                setProfile(JSON.parse(userProfileStr));
        }
    }, [userProfileStatus]);
    const handleAvatarUpdate = useCallback((chosenFile) => {
        const file = Array.isArray(chosenFile) ? chosenFile[0] : chosenFile;
        withAttachments(updateAvatar)({
            variables: { avatar: file, userId: userProfileData.id },
            refetchQueries: [{ query: PROFILE }],
        }).then((res) => {
            dispatch(updateUserAvatarStore(res.data.updateUser.user.avatar));
        });
    }, [dispatch, userProfileData, updateAvatar]);
    const handleAvatarDelete = () => {
        dispatch(updateUserAvatar({ userId: userProfileData.id, avatar: '' }));
    };
    if (userProfileStatus !== 'succeeded')
        return React.createElement(Loader, null);
    return (React.createElement(Dashboard, null,
        React.createElement(Grid, { columns: "aside_left", vp: 24, hp: 24, gap: 48 },
            React.createElement(Grid, { gap: 12 },
                React.createElement(Subtitle, null, t('avatar')),
                React.createElement(Photo, { size: "l", theme: "avatar", standalone: true, src: userProfileData.avatar ? `${env.static}/${userProfileData.avatar}` : null, onPhotoAdd: handleAvatarUpdate, onPhotoDelete: handleAvatarDelete })),
            React.createElement(Grid, { gap: 12 },
                React.createElement(Subtitle, null, t('basic_info')),
                React.createElement(ParameterDetails, { label: t('username'), value: userProfileData === null || userProfileData === void 0 ? void 0 : userProfileData.username }),
                React.createElement(ParameterDetails, { label: t('email'), value: userProfileData === null || userProfileData === void 0 ? void 0 : userProfileData.email }),
                React.createElement(ParameterDetails, { label: t('firstName'), value: profile === null || profile === void 0 ? void 0 : profile.firstName }),
                React.createElement(ParameterDetails, { label: t('lastName'), value: profile === null || profile === void 0 ? void 0 : profile.lastName })))));
}
export default memo(UserProfileView);
